import { create } from "zustand"
import ProlongationService from "../API/ProlongationService"

export const useProlongationsStore = create((set, get) => ({
    prolongations: [],
    setProlongations: (newProlongations) => set({ prolongations: newProlongations }),
    updateProlongation: (prolongation) => set({
        prolongations: get().prolongations.map(pr => pr.prolongation_id === prolongation.prolongation_id ? prolongation : pr)
    }),
    updatePurchaseCommType: (id, type) => set(state => ({
        prolongations: state.prolongations.map((p) => {
            if (p.student_id === id)
                p.communication_type = type
            return p
        })
    })),

    mailingStatuses: [],
    setMailingStatuses: (statuses) => set({ mailingStatuses: statuses }),
    fetchMailingStatuses: async () => {
        if (get().mailingStatuses.length < 1) {
            const response = await ProlongationService.getMailingStatuses()
            if (response?.status === 200) {
                set({ mailingStatuses: response.data })
            }
        }
    },
}))
